import { UnitCardTypes } from '../UnitCardTypes';
export const errorMessageHeading = 'Looks Like Something Is Wrong from Our End';
export const errorMessagePara = 'To Go Back And Try Again';
export const errorImageUrl =
  'https://tfw-v11-assets.s3.us-east-1.amazonaws.com/demo-website/storage.png';
export const unitCardsConfig: UnitCardTypes.TUnitCardsConfig = {
  cardHeading: 'Unit Details',
  unitTypeHeading: 'Selected Unit Type',
  unitNumberHeading: 'Selected Unit Number',
  isConfirmationPage: true,
  billingCycleDetails: {
    title: 'Billing Cycle',
    billingCycle: ['Monthly'],
  },
  callToAction: {
    label: 'Change',
    show: true,
  },
  amenitiesHeading: 'Included Amenities',
  ratesDetails: {
    ratesTitle: 'Applicable Rates',
    rentalTitle: 'Rent',
    depositTitle: 'Rental Deposit',
    reservationTitle: 'Reservation Deposit',
    setupTitle: 'Setup Fee',
    sumTitle: 'Total',
    surCharge: 'SurCharge',
    discount: 'Discount',
    promoPlanTitle: 'Promotional Plans',
  },
  promoPlans: {
    promoPlansApplied: 'Promo plan applied',
    title: 'Promotional Plans',
    applyPromoCode: 'Apply Promo Code',
    noPromoPlans: 'No applicable promo plans for selected unit type',
  },
  unitTypeModal: {
    title: 'Select A Unit',
    modalHeaderDetails: {
      header: {
        RowOne: 'Unit Size',
        RowTwo: 'Category',
        RowThree: 'Price',
        RowOneForTablet: 'Unit Type',
      },
      callToAction: {
        label: 'Click Here',
        show: true,
      },
    },
  },
  iconsList: {
    iconOne: {
      name: 'FaPlus',
      size: 16,
    },
    iconTwo: {
      name: 'FaMinus',
      size: 16,
    },
  },
};
